export default "__VITE_ASSET__DbhV0FJv__"